const links = [
  {
    name: "About Us",
    path: "/about_us",
  },
  {
    name: "Contact Us",
    path: "/contact_us",
  },
  {
    name: "Privacy",
    path: "/privacy",
  },
  {
    name: "Terms",
    path: "/terms",
  },
  {
    name: "Refund Policy",
    path: "/refund_policy",
  },
  {
    name: "Pricing Details",
    path: "/pricing_details",
  },
  {
    name: "Brochure",
    path: `${process.env.PUBLIC_URL}/brochure.pdf`,
  },
];

export const privacyData = [
  {
    label: "SECTION 1 - WHAT DO WE DO WITH YOUR INFORMATION?",
    value:
      "During each transaction, we collect the following information: * Consumer Number * Meter Number * Recharge Amount * Email Address All these information are used only for recored keeping purposes and usage analysis reports by the Department of Power, Government of Nagaland. No details of your payment instrument (Bank AC number, Debit/ Credit Card number etc.) are stored in our servers.",
  },
  {
    label: "SECTION 2 - CONSENT",
    value:
      "How do you get my consent? When you provide us with personal information to complete a transaction, verify your credit card, place an order, arrange for a delivery or return a purchase, we imply that you consent to our collecting it and using it for that specific reason only. If we ask for your personal information for a secondary reason, like marketing, we will either ask you directly for your expressed consent, or provide you with an opportunity to say no. How do I withdraw my consent?",
  },
  {
    label: "SECTION 3 - DISCLOSURE",
    value:
      "We may disclose your personal information if we are required by law to do so or if you violate our Terms of Service.",
  },
  {
    label: "SECTION 4 - PAYMENT",
    value:
      "We use Razorpay for processing payments. We/Razorpay do not store your card data on their servers. The data is encrypted through the Payment Card Industry Data Security Standard (PCI-DSS) when processing payment. Your purchase transaction data is only used as long as is necessary to complete your purchase transaction. After that is complete, your purchase transaction information is not saved. Our payment gateway adheres to the standards set by PCI-DSS as managed by the PCI Security Standards Council, which is a joint effort of brands like Visa, MasterCard, American Express and Discover. PCI-DSS requirements help ensure the secure handling of credit card information by our store and its service providers. For more insight, you may also want to read terms and conditions of razorpay on https://razorpay.com.",
  },
  {
    label: "SECTION 5 - THIRD-PARTY SERVICES",
    value:
      "In general, the third-party providers used by us will only collect, use and disclose your information to the extent necessary to allow them to perform the services they provide to us. However, certain third-party service providers, such as payment gateways and other payment transaction processors, have their own privacy policies in respect to the information we are required to provide to them for your purchase-related transactions. For these providers, we recommend that you read their privacy policies so you can understand the manner in which your personal information will be handled by these providers. In particular, remember that certain providers may be located in or have facilities that are located a different jurisdiction than either you or us. So if you elect to proceed with a transaction that involves the services of a third-party service provider, then your information may become subject to the laws of the jurisdiction(s) in which that service provider or its facilities are located. Once you leave our store’s website or are redirected to a third-party website or application, you are no longer governed by this Privacy Policy or our website’s Terms of Service. Links When you click on links on our store, they may direct you away from our site. We are not responsible for the privacy practices of other sites and encourage you to read their privacy statements.",
  },
  {
    label: "SECTION 6 - SECURITY",
    value:
      "To protect your personal information, we take reasonable precautions and follow industry best practices to make sure it is not inappropriately lost, misused, accessed, disclosed, altered or destroyed.",
  },
  {
    label: "SECTION 7 - COOKIES",
    value:
      "We use cookies to maintain session of your user. It is not used to personally identify you on other websites.",
  },
  {
    label: "SECTION 8 - AGE OF CONSENT",
    value:
      "By using this site, you represent that you are at least the age of majority in your state or province of residence, or that you are the age of majority in your state or province of residence and you have given us your consent to allow any of your minor dependents to use this site.",
  },
  {
    label: "SECTION 8 - THIRD-PARTY LINKS",
    value:
      "Certain content, products and services available via our Service may include materials from third-parties. Third-party links on this site may direct you to third-party websites that are not affiliated with us. We are not responsible for examining or evaluating the content or accuracy and we do not warrant and will not have any liability or responsibility for any third-party materials or websites, or for any other materials, products, or services of third-parties. We are not liable for any harm or damages related to the purchase or use of goods, services, resources, content, or any other transactions made in connection with any third-party websites. Please review carefully the third-party's policies and practices and make sure you understand them before you engage in any transaction. Complaints, claims, concerns, or questions regarding third-party products should be directed to the third-party. ",
  },
  {
    label: "SECTION 9 - CHANGES TO THIS PRIVACY POLICY",
    value:
      "We reserve the right to modify this privacy policy at any time, so please review it frequently. Changes and clarifications will take effect immediately upon their posting on the website. If we make material changes to this policy, we will notify you here that it has been updated, so that you are aware of what information we collect, how we use it, and under what circumstances, if any, we use and/or disclose it. If our store is acquired or merged with another company, your information may be transferred to the new owners so that we may continue to sell products to you. QUESTIONS AND CONTACT INFORMATION If you would like to: access, correct, amend or delete any personal information we have about you, register a complaint, or simply want more information contact our Privacy Compliance Officer by mail at ben@universalpowers.in ----",
  },
];

export default links;
